import _objectSpread from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _slicedToArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
import { isUriLocation, objectHash } from '@jbrowse/core/util';
import { openLocation } from '@jbrowse/core/util/io';
import { generateUnsupportedTrackConf, generateUnknownTrackConf } from '@jbrowse/core/util/tracks';
import ucscAssemblies from './ucscAssemblies';
export { ucscAssemblies };
export function fetchHubFile(_x) {
  return _fetchHubFile.apply(this, arguments);
}
function _fetchHubFile() {
  _fetchHubFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(hubLocation) {
    var hubFileText, _yield$import, HubFile;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return openLocation(hubLocation).readFile('utf8');
        case 3:
          hubFileText = _context.sent;
          _context.next = 6;
          return import('@gmod/ucsc-hub');
        case 6:
          _yield$import = _context.sent;
          HubFile = _yield$import.HubFile;
          return _context.abrupt("return", new HubFile(hubFileText));
        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](0);
          throw new Error("Not a valid hub.txt file, got error: '".concat(_context.t0, "'"));
        case 14:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 11]]);
  }));
  return _fetchHubFile.apply(this, arguments);
}
export function fetchGenomesFile(_x2) {
  return _fetchGenomesFile.apply(this, arguments);
}
function _fetchGenomesFile() {
  _fetchGenomesFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(genomesLoc) {
    var genomesFileText, _yield$import2, GenomesFile;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return openLocation(genomesLoc).readFile('utf8');
        case 2:
          genomesFileText = _context2.sent;
          _context2.next = 5;
          return import('@gmod/ucsc-hub');
        case 5:
          _yield$import2 = _context2.sent;
          GenomesFile = _yield$import2.GenomesFile;
          return _context2.abrupt("return", new GenomesFile(genomesFileText));
        case 8:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _fetchGenomesFile.apply(this, arguments);
}
export function fetchTrackDbFile(_x3) {
  return _fetchTrackDbFile.apply(this, arguments);
}
function _fetchTrackDbFile() {
  _fetchTrackDbFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(trackDbLoc) {
    var text, _yield$import3, TrackDbFile;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return openLocation(trackDbLoc).readFile('utf8');
        case 2:
          text = _context3.sent;
          _context3.next = 5;
          return import('@gmod/ucsc-hub');
        case 5:
          _yield$import3 = _context3.sent;
          TrackDbFile = _yield$import3.TrackDbFile;
          return _context3.abrupt("return", new TrackDbFile(text));
        case 8:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _fetchTrackDbFile.apply(this, arguments);
}
export function makeLoc(first, base) {
  return {
    uri: new URL(first, base.uri).href,
    locationType: 'UriLocation'
  };
}
export function makeLocAlt(first, alt, base) {
  return first ? makeLoc(first, base) : makeLoc(alt, base);
}
export function makeLoc2(first, alt) {
  return first ? {
    uri: first,
    locationType: 'LocalPath'
  } : {
    uri: alt,
    locationType: 'UriLocation'
  };
}
export function generateTracks(trackDb, trackDbLoc, assemblyName, sequenceAdapter) {
  var tracks = [];
  trackDb.forEach(function (track, trackName) {
    var _a;
    var trackKeys = Array.from(track.keys());
    var parentTrackKeys = ['superTrack', 'compositeTrack', 'container', 'view'];
    if (trackKeys.some(function (key) {
      return parentTrackKeys.includes(key);
    })) {
      return;
    }
    var parentTracks = [];
    var currentTrackName = trackName;
    do {
      currentTrackName = ((_a = trackDb.get(currentTrackName)) === null || _a === void 0 ? void 0 : _a.get('parent')) || '';
      if (currentTrackName) {
        ;
        var _currentTrackName$spl = currentTrackName.split(' ');
        var _currentTrackName$spl2 = _slicedToArray(_currentTrackName$spl, 1);
        currentTrackName = _currentTrackName$spl2[0];
        parentTracks.push(trackDb.get(currentTrackName));
      }
    } while (currentTrackName);
    parentTracks.reverse();
    var categories = parentTracks.map(function (p) {
      return p === null || p === void 0 ? void 0 : p.get('shortLabel');
    }).filter(function (f) {
      return !!f;
    });
    var res = makeTrackConfig(track, categories, trackDbLoc, trackDb, sequenceAdapter);
    tracks.push(_objectSpread({}, res, {
      trackId: "ucsc-trackhub-".concat(objectHash(res)),
      assemblyNames: [assemblyName]
    }));
  });
  return tracks;
}
function makeTrackConfig(track, categories, trackDbLoc, trackDb, sequenceAdapter) {
  var _a;
  var trackType = track.get('type');
  var name = track.get('shortLabel') || '';
  var bigDataUrl = track.get('bigDataUrl') || '';
  var bigDataIdx = track.get('bigDataIndex') || '';
  var isUri = isUriLocation(trackDbLoc);
  if (!trackType) {
    trackType = (_a = trackDb.get(track.get('parent') || '')) === null || _a === void 0 ? void 0 : _a.get('type');
  }
  var baseTrackType = (trackType === null || trackType === void 0 ? void 0 : trackType.split(' ')[0]) || '';
  if (baseTrackType === 'bam' && bigDataUrl.toLowerCase().endsWith('cram')) {
    baseTrackType = 'cram';
  }
  var bigDataLocation = isUri ? makeLoc(bigDataUrl, trackDbLoc) : makeLoc2(bigDataUrl);
  switch (baseTrackType) {
    case 'bam':
      return {
        type: 'AlignmentsTrack',
        name: track.get('shortLabel'),
        description: track.get('longLabel'),
        category: categories,
        adapter: {
          type: 'BamAdapter',
          bamLocation: bigDataLocation,
          index: {
            location: isUri ? makeLocAlt(bigDataIdx, bigDataUrl + '.bai', trackDbLoc) : makeLoc2(bigDataIdx, bigDataUrl + '.bai')
          }
        }
      };
    case 'bigBarChart':
      return {
        type: 'FeatureTrack',
        name: name,
        description: track.get('longLabel'),
        category: categories,
        adapter: {
          type: 'BigBedAdapter',
          bigBedLocation: bigDataLocation
        },
        renderer: {
          type: 'SvgFeatureRenderer'
        }
      };
    case 'bigBed':
      return {
        type: 'FeatureTrack',
        name: name,
        description: track.get('longLabel'),
        category: categories,
        adapter: {
          type: 'BigBedAdapter',
          bigBedLocation: bigDataLocation
        }
      };
    case 'bigGenePred':
      return {
        type: 'FeatureTrack',
        name: name,
        description: track.get('longLabel'),
        category: categories,
        adapter: {
          type: 'BigBedAdapter',
          bigBedLocation: bigDataLocation
        }
      };
    case 'bigChain':
      return {
        type: 'FeatureTrack',
        name: name,
        description: track.get('longLabel'),
        category: categories,
        adapter: {
          type: 'BigBedAdapter',
          bigBedLocation: bigDataLocation
        },
        renderer: {
          type: 'SvgFeatureRenderer'
        }
      };
    case 'bigInteract':
      return {
        type: 'FeatureTrack',
        name: name,
        description: track.get('longLabel'),
        category: categories,
        adapter: {
          type: 'BigBedAdapter',
          bigBedLocation: bigDataLocation
        },
        renderer: {
          type: 'SvgFeatureRenderer'
        }
      };
    case 'bigMaf':
      return {
        type: 'FeatureTrack',
        name: name,
        description: track.get('longLabel'),
        category: categories,
        adapter: {
          type: 'BigBedAdapter',
          bigBedLocation: bigDataLocation
        },
        renderer: {
          type: 'SvgFeatureRenderer'
        }
      };
    case 'bigPsl':
      return {
        type: 'FeatureTrack',
        name: name,
        description: track.get('longLabel'),
        category: categories,
        adapter: {
          type: 'BigBedAdapter',
          bigBedLocation: bigDataLocation
        },
        renderer: {
          type: 'SvgFeatureRenderer'
        }
      };
    case 'bigWig':
      return {
        type: 'QuantitativeTrack',
        name: name,
        description: track.get('longLabel'),
        category: categories,
        adapter: {
          type: 'BigWigAdapter',
          bigWigLocation: bigDataLocation
        }
      };
    case 'cram':
      return {
        type: 'AlignmentsTrack',
        name: name,
        description: track.get('longLabel'),
        category: categories,
        adapter: {
          type: 'CramAdapter',
          cramLocation: bigDataLocation,
          craiLocation: isUri ? makeLocAlt(bigDataIdx, bigDataUrl + '.crai', trackDbLoc) : makeLoc2(bigDataIdx, bigDataUrl + '.crai'),
          sequenceAdapter: sequenceAdapter
        }
      };
    case 'bigNarrowPeak':
      return {
        type: 'FeatureTrack',
        name: name,
        description: track.get('longLabel'),
        category: categories,
        adapter: {
          type: 'BigBedAdapter',
          bigBedLocation: bigDataLocation
        }
      };
    case 'peptideMapping':
      return generateUnsupportedTrackConf(name, baseTrackType, categories);
    case 'vcfTabix':
      return {
        type: 'VariantTrack',
        name: name,
        description: track.get('longLabel'),
        category: categories,
        adapter: {
          type: 'VcfTabixAdapter',
          vcfGzLocation: bigDataLocation,
          index: {
            location: isUri ? makeLocAlt(bigDataIdx, bigDataUrl + '.tbi', trackDbLoc) : makeLoc2(bigDataIdx, bigDataUrl + '.tbi')
          }
        }
      };
    case 'hic':
      return {
        type: 'HicTrack',
        name: name,
        description: track.get('longLabel'),
        category: categories,
        adapter: {
          type: 'HicAdapter',
          hicLocation: bigDataLocation
        }
      };
    // unsupported types
    //     case 'gvf':
    //     case 'ld2':
    //     case 'narrowPeak':
    //     case 'wig':
    //     case 'wigMaf':
    //     case 'halSnake':
    //     case 'bed':
    //     case 'bed5FloatScore':
    //     case 'bedGraph':
    //     case 'bedRnaElements':
    //     case 'broadPeak':
    //     case 'coloredExon':
    default:
      return generateUnknownTrackConf(name, baseTrackType, categories);
  }
}